import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EndPointGetterService } from '../utilities/end-point-getter.service';
import { Role } from './models';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RoleService {

  constructor(private http: HttpClient, private epGetter: EndPointGetterService) { }

  getRoles(): Observable<Role[]> {
    return this.http.get<Role[]>(this.epGetter.getEndPointUrl() + '/roles');
  }

  getRole(id: number): Observable<Role> {
    return this.http.get<Role>(this.epGetter.getEndPointUrl() + '/roles/' + id);
  }

  postRole(role: Role): Observable<any> {
    return this.http.post(this.epGetter.getEndPointUrl() + '/roles', role);
  }

  putRole(role: Role): Observable<any> {
    return this.http.put(this.epGetter.getEndPointUrl() + '/roles/' + role.roleId, role);
  }

  deleteRole(id: number): Observable<Role> {
    return this.http.delete<Role>(this.epGetter.getEndPointUrl() + '/roles/' + id);
  }
}
